const Location = Object.freeze({
  UNKNOWN: "UNKNOWN",
  HOME_PAGE: "HOME_PAGE",
  PRODUCT_PAGE: "PRODUCT_PAGE",
  CART: "CART",
  TREATMENT_PAGE: "TREATMENT_PAGE",
  WEBSHOP_FRONT_PAGE: "WEBSHOP_FRONT_PAGE",
  PORTAL_PAGE: "PORTAL_PAGE",
  EMPLOYEE_PAGE: "EMPLOYEE_PAGE",
});

export default Location;
